<template>
  <div style="height: 100%;">
    <div class="topPart">
      <div class="return" @click="OrderInfoReturn"></div>
      <a href="https://m.tunnelling.cn/Manager/MemberIndex.aspx"
        ><img :src="imgUrl" alt=""
      /></a>
    </div>
    <OrdersDetail :id="infoId" :orderId="orderId" />
  </div>
</template>

<script>
import OrdersDetail from "../../components/OrdersDetail.vue";
export default {
  name: "OrderInfo",
  data() {
    return {
      imgUrl: "", // 头像
      infoId: undefined, // 订单详情id
      orderId: undefined // 订单id
    };
  },
  created() {
    this.infoId = this.$route.query.infoId;
    this.orderId = this.$route.query.orderId;
  },
  mounted() {
    this.GetUserInfo();
  },
  methods: {
    // 获取用户信息
    GetUserInfo() {
      this.$fetch("/Login")
        .then(res => {
          if (res.data.accessAllowed === false) return;
          this.imgUrl = res.data.imagePath;
        })
        .catch(err => {
          throw err;
        });
    },
    // 返回
    OrderInfoReturn() {
      // sessionStorage.setItem('loadOrder','is');
      this.$router.go(-1);
    }
  },
  components: {
    OrdersDetail
  }
};
</script>

<style scoped>
.topPart {
  width: 100%;
  height: 0.88rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
}
.topPart img {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  margin-right: 0.25rem;
}
.topPart .return {
  width: 0.4rem;
  height: 0.4rem;
  background: url(../../assets/img/return_mobile.svg) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0.25rem;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/MemberCenter/OrderInfo.vue